<canvas #canvas></canvas>
<ng-content></ng-content>
